import React, { useState } from "react";

const TablePicker = ({ onSelect }) => {
    const maxRows = 15;
    const maxCols = 6;

    const [hovered, setHovered] = useState({ rows: 0, cols: 0 });

    return (
        <div style={styles.container}>
            <div style={styles.label}>
                {hovered.rows} x {hovered.cols}
            </div>

            {[...Array(maxRows)].map((_, r) => (
                <div key={r} style={{ display: "flex" }}>
                    {[...Array(maxCols)].map((_, c) => {
                        const active = r < hovered.rows && c < hovered.cols;

                        return (
                            <div
                                key={c}
                                onMouseEnter={() =>
                                    setHovered({ rows: r + 1, cols: c + 1 })
                                }
                                onClick={() => onSelect(r + 1, c + 1)}
                                style={{
                                    width: 18,
                                    height: 18,
                                    margin: 1,
                                    border: "1px solid #d6d6d6",
                                    background: active ? "#ffa500" : "#fff",
                                    boxSizing: "border-box",
                                    cursor: "pointer",
                                }}
                            />
                        );
                    })}
                </div>
            ))}
        </div>
    );
};

const styles = {
    container: {
        position: "absolute",
        background: "#fff",
        border: "1px solid #ccc",
        padding: 6,
        zIndex: 1000,
        marginTop: 5,
        boxShadow: "0 2px 6px rgba(0,0,0,0.2)",
    },
    label: {
        fontSize: 12,
        marginBottom: 5,
    },
};

export default TablePicker;